<template>
    <main class="dashboard">
        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253)">
            <div class="container">
                <div class="has-background-white tipo_negocio pt-3">
                    <div class="">
                        <section>
                            <div class="title_type is-flex is-justify-content-center is-align-items-center"
                                style="position: relative">
                                <div style="position: absolute; left: 0" class="is-flex is-justify-content-start">
                                    <span class="theme_btn_dark is-clickable ml-3 mr-3"
                                        @click="() => uploadAllPlanAccounts()">Importar</span>
                                    <a class="download_btn is-flex is-justify-content-start is-clickable"
                                        :href="`${hostname}/xlsx/${templateName}.xlsx`">
                                        <component :is="'DownloadFile'"></component>
                                        <span class="text_month ml-1">Descargar Plantilla</span>
                                    </a>
                                    <input type="file" ref="fileInput" @change="
                                        (e) => uploadFilePlanAccounts(e)
                                    " accept=".xlsx,.xls" style="display: none" />
                                </div>
                                <span class="">Plan de Cuentas</span>
                                <div style="position: absolute; right: 0">
                                    <span v-if="has_repeated_plan_account" @click="() => makeAccountPlansUnique()"
                                        class="theme_btn_red is-clickable">
                                        Hacer único
                                    </span>

                                    <span class="theme_btn_white is-clickable ml-3"
                                        @click="() => downloadAllPlanAccounts()">Exportar</span>
                                    <span v-if="basic_data && basic_data.needs_account_plan_review"
                                        class="theme_btn_blue is-clickable ml-3"
                                        @click="() => approveAccountPlanReview()">
                                        Completado
                                    </span>
                                </div>
                            </div>
                            <p class="subtitle_type">
                                Cuentas {{ consolidatedBusinessType }}
                            </p>
                        </section>
                        <div class="px-4 mb-2 is-hidden-mobile">
                            <div class="columns is-vcentered is-uppercase is-size-7">
                                <div class="column is-1 has-text-right has-text-weight-bold">
                                    Nro.
                                </div>
                                <div class="column is-2 has-text-weight-semibold">
                                    Nivel 1
                                </div>
                                <div class="column is-3 has-text-weight-semibold">
                                    Nivel 2
                                </div>
                                <div class="column is-4 has-text-weight-semibold">
                                    Nivel 3 / Cuenta
                                </div>
                                <div class="column is-1 has-text-weight-semibold">
                                    Orden
                                </div>
                                <div class="column is-1 has-text-weight-semibold">
                                    Operaciones
                                </div>
                            </div>
                        </div>

                        <div v-for="(item, index) in account_plans" :key="item.id" :class="[
                            'box px-3 py-2 mb-1 shadow-sm',
                            getRowBackground(index),
                        ]">
                            <div class="columns is-vcentered">
                                <div class="column py-2 is-1">
                                    <p class="is-size-6 has-text-weight-semibold has-text-right">
                                        {{ index + 1 }}.-
                                    </p>
                                </div>
                                <div class="column py-2 is-2">
                                    <p class="is-size-6 has-text-weight-semibold">
                                        {{ item.level_1 }}
                                    </p>
                                </div>
                                <div class="column py-2 is-3">
                                    <p class="is-size-7-mobile">
                                        {{ item.level_2 }}
                                    </p>
                                </div>
                                <div class="column py-2 is-4">
                                    <p class="is-size-7-mobile">
                                        {{ item.level_3 }}
                                    </p>
                                </div>
                                <div class="column py-2 is-1">
                                    <span class="tag is-rounded is-primary has-text-weight-bold">
                                        {{ item.order }}
                                    </span>
                                </div>
                                <div class="column py-2 is-1">
                                    <span class="tag is-rounded has-text-weight-bold is-clickable" @click="
                                        () =>
                                            initializeEditingPlanAccount(
                                                index,
                                            )
                                    ">
                                        <EditPencil />
                                    </span>
                                    <span class="tag is-rounded has-text-weight-bold is-clickable" @click="
                                        () => openConfirmRestoreModal('delete', item.id)
                                    ">
                                        <Trash />
                                    </span>
                                </div>
                            </div>

                            <div v-if="indexEditing == index" class="columns is-vcentered">
                                <div class="column py-2 is-3">
                                    <b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
                                        id="level_1_select" v-model="level1Editing" placeholder="Nivel 1"
                                        rules="required" @change.native="(e) => onLevel1Change(e.target.value)">
                                        <option v-for="value in level_1_values" :key="value.name" :value="value.name">
                                            {{ value.name }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="column py-2 is-3">
                                    <b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
                                        id="level_2_select" v-model="level2Editing" placeholder="Nivel 2"
                                        :key="level_2_values_depending.length" rules="required">
                                        <option v-for="value in level_2_values_depending" :key="value.id"
                                            :value="value.id">
                                            {{ value.level_2 }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="column py-2 is-3">
                                    <b-input size="is-small" expanded class="new_cuenta new_elem_row"
                                        placeholder="Cuenta" v-model="level3Editing" />
                                </div>
                                <div class="column py-2 is-3">
                                    <div class="field has-addons">
                                        <div class="control is-expanded mr-1">
                                            <b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Orden"
                                                v-model="orderEditing" />
                                        </div>
                                        <div class="control is-vcentered py-2">
                                            <span @click="
                                                () =>
                                                    openConfirmRestoreModal('edit', item.id)
                                            " class="is-small theme_btn_dark is-clickable" style="height: 100%">
                                                OK
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box px-3 py-2 mb-1 shadow-sm">
                            <div class="columns is-vcentered">
                                <div class="column py-2 is-3">
                                    <b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
                                        id="level_1_select" v-model="new_level_1_value" placeholder="Nivel 1"
                                        rules="required" v-on:input="onLevel1Change">
                                        <option v-for="value in level_1_values" :key="value.name" :value="value.name">
                                            {{ value.name }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="column py-2 is-3">
                                    <b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
                                        id="level_2_select" v-model="new_level_2_value" placeholder="Nivel 2"
                                        rules="required">
                                        <option v-for="value in level_2_values_depending" :key="value.id"
                                            :value="value.id">
                                            {{ value.level_2 }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="column py-2 is-3">
                                    <b-input size="is-small" expanded class="new_cuenta new_elem_row"
                                        placeholder="Cuenta" v-model="newAccount" />
                                </div>
                                <div class="column py-2 is-3">
                                    <div class="field has-addons">
                                        <div class="control is-expanded mr-1">
                                            <b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Orden"
                                                v-model="new_order" />
                                        </div>
                                        <div class="control is-vcentered py-2">
                                            <span @click="addAccount" class="is-small theme_btn_blue is-clickable"
                                                style="height: 100%">
                                                +
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {
    approveAccountPlan,
    createAccount,
    deleteAccount,
    editAccount,
    getAccountPlanForCompany,
    makeUniquePlanAccounts,
    saveAccountPlans,
    upload_all_plan_accounts,
} from "@/api/carteraAnalista";
import ConfirmRestore from "@/components/modals/ConfirmRestore";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import EditPencil from "@/components/svg/EditPencil";
import Trash from "@/components/svg/Trash";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
    name: "CompanyInfoAccountPlan",
    props: {
        basicData: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    components: {
        EditPencil,
        Trash,
        DownloadFile
    },
    created() { },
    mounted() {
        if (this.basic_data && this.basic_data.companyId) {
            this.loadDefaultPlans()
        }
    },
    data() {
        return {
            consolidatedBusinessType: "_",
            basic_data: {},
            super_types: [],
            checked: {},
            already_saved: {},
            account_plans: [],
            new_level_1_value: "",
            new_level_2_value: "",
            level_1_values: [],
            level_2_values: {},
            level_2_values_depending: [],
            newAccount: "",
            new_order: 0,
            level1Editing: "",
            level2Editing: "",
            level3Editing: "",
            orderEditing: "",
            templateName: "",
            has_repeated_plan_account: false,
            indexEditing: -1,
            modalDefault: {
                parent: this,
                width: "25%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
        };
    },
    computed: {
        hostname() {
            const publicPath = window.location.hostname
            const localhost = ["localhost", "0.0.0.0"]
            if (localhost.includes(window.location.hostname)) {
                return `http://${publicPath}`;
            } else {
                return `https://${publicPath}`;
            }
        },
    },
    methods: {
        approveAccountPlanReview() {
            // Visto bueno del analista: baja el banner "En revisión" del cliente.
            approveAccountPlan(this.basic_data.companyId)
                .then(() => {
                    this.basic_data.needs_account_plan_review = false;
                    notificate("Visto bueno dado al plan de cuentas.");
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                });
        },
        getRowBackground(index) {
            let groupIndex = 0;
            for (let i = 0; i <= index; i++) {
                if (
                    i > 0 &&
                    this.account_plans[i].level_2 !==
                    this.account_plans[i - 1].level_2
                ) {
                    groupIndex++;
                }
            }

            return groupIndex % 2 === 0 ? "bg-group-a" : "bg-group-b";
        },
        initializeEditingPlanAccount(iPlan) {
            this.indexEditing = iPlan;
        },
        onLevel1Change(val) {
            this.level_2_values_depending = this.level_2_values[val]["items"];
        },
        async addAccount() {
            if (
                !this.basic_data.companyId ||
                !this.new_level_2_value ||
                !this.newAccount
            ) {
                notificate("Debe llenar los datos.");
                return;
            }
            try {
                const resp = await createAccount(
                    this.basic_data.companyId,
                    this.new_level_2_value,
                    this.newAccount,
                    this.new_order,
                );
                if (resp.data["status"] == "Ok") {
                    notificate("Cuenta grabada exitosamente.");
                } else {
                    notificate(resp.data["status"]);
                }
                this.new_level_2_value = "";
                this.newAccount = "";
                this.new_level_1_value = "";
                this.new_order = "";
                await this.loadDefaultPlans();
            } catch (error) {
                consoleHandlerError({ error, empty: true });
            }
        },
        async editPlanAccount(idPlanAccount) {
            if (
                !this.basic_data.companyId ||
                !this.level2Editing ||
                !this.level3Editing ||
                !this.orderEditing
            ) {
                notificate("Debe llenar todos los datos.");
                return;
            }
            try {
                const { data } = await editAccount(
                    this.basic_data.companyId,
                    idPlanAccount,
                    this.level2Editing,
                    this.level3Editing,
                    this.orderEditing,
                );
                if (data["status"] == "Ok") {
                    notificate("Cuenta grabada exitosamente.");
                } else {
                    notificate(data["status"]);
                }

                this.level1Editing = "";
                this.level2Editing = "";
                this.level3Editing = "";
                this.orderEditing = "";
                this.indexEditing = -1;
                await this.loadDefaultPlans();
            } catch (error) {
                consoleHandlerError({ error, empty: true });
            }
        },
        async deletePlanAccount(idPlanAccount) {
            try {
                await deleteAccount(this.basic_data.companyId, idPlanAccount);
                notificate("Plan de cuenta borrado");
            } catch (err) {
                notificate("Ocurrio un error");
                console.log(
                    "%csrc/views/CompanyInfo_AccountPlan.vue:340 err",
                    "color: #007acc;",
                    err,
                );
            } finally {
                await this.loadDefaultPlans();
            }
        },
        async saveAccountPlansChanges() {
            const response = saveAccountPlans(
                this.basic_data.companyId,
                this.checked,
                this.already_saved,
            );
            const resp = await response;
            await this.loadDefaultPlans();
            if (resp.data["status"] == "Ok") {
                notificate("Plan de Cuentas grabado exitosamente.");
            } else {
                notificate(resp.data["status"]);
            }
        },
        toggle(key) {
            const newChecked = { ...this.checked };
            newChecked[key] = !newChecked[key];
            this.checked = newChecked;
        },
        async loadDefaultPlans() {
            if (this.basic_data && this.basic_data.companyId) {
                const response = await getAccountPlanForCompany(
                    this.basic_data.companyId,
                );
                this.level_1_values = response.data["level_1_values"];
                this.level_2_values = response.data["level_2_values"];
                this.account_plans = response.data["account_plans"];
                this.has_repeated_plan_account =
                    response.data["has_repeated_plan_account"];
                if (!this.basic_data.classify_by_sales) {
                    this.account_plans = this.account_plans.filter(
                        (elem) => elem.level_1 != "Ventas",
                    );
                    this.level_1_values = this.level_1_values.filter(
                        (elem) => elem.name != "Ventas",
                    );
                }
                for (let i = 0; i < this.account_plans.length; i++) {
                    let isIn = false;
                    if (this.account_plans[i].saved) {
                        isIn = true;
                        this.already_saved["ap_" + this.account_plans[i].id] =
                            this.account_plans[i].apc_id;
                    }
                    this.checked["ap_" + this.account_plans[i].id] = isIn;
                }
                this.consolidatedBusinessType =
                    response.data["tipo_negocio_consolidado"];
            }
        },
        checkAllAccounts() {
            const newChecked = { ...this.checked };
            for (const key in this.checked) {
                newChecked[key] = true;
            }
            this.checked = newChecked;
        },
        makeAccountPlansUnique() {
            makeUniquePlanAccounts(this.basic_data.companyId).then(() => {
                this.loadDefaultPlans();
            });
        },
        async downloadAllPlanAccounts() {
            // Carga la librería dinámicamente solo cuando se necesita
            const XLSX = await import('xlsx');
            let data = []
            this.account_plans.map((plan) => {
                data.push({
                    "Nivel 1": plan.level_1,
                    "Nivel 2": plan.level_2,
                    "Nivel 3": plan.level_3,
                })
            });


            // Crear hoja y libro de trabajo
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Plan de cuentas");

            // Generar y descargar el archivo
            XLSX.writeFile(workbook, "Plan de cuentas.xlsx");
        },
        uploadAllPlanAccounts() {
            this.$refs.fileInput.click();
        },
        uploadFilePlanAccounts(e) {
            const file = e.target.files[0];
            e.target.value = null;
            if (!file) return;

            const formData = new FormData();
            formData.append("planAccountsFile", file);

            upload_all_plan_accounts(this.basic_data.companyId, formData)
                .then(({ data }) => {
                    if (data.result) {
                        throw new Error(data.result)
                    }
                    this.loadDefaultPlans();
                    notificate(
                        `<strong>Subido con éxito</strong>
                        <br>el archivo se subio correctamente`,
                        "is-success is-light"
                    );
                })
                .catch((err) => {
                    console.log('%csrc/views/CompanyInfo_AccountPlan.vue:455 err', 'color: #007acc;', err);
                    notificate(
                        `<strong>Error</strong>
                        <br>hubo un problema con ${err}`,
                        "is-danger is-light"
                    );
                    console.error("Error, no se pudo subir el archivo", err);
                });
        },
        openConfirmRestoreModal(type, idPlanAccount) {
            let title = 'eliminar'
            let subTitle = 'Esta acción revertirá todos los cambios en prorratas y devengo'
            if (type == 'edit') {
                title = 'editar'
                subTitle = 'Esta acción cambiara la clasificación de todos los documentos asociados a esta cuenta'
            }
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ConfirmRestore,
                props: {
                    eventNameConfirmRestore: 'confirmEvent',
                    tittleRestore: '¿Desea ' + title + ' esta cuenta?',
                    subTittleRestore: subTitle,
                    msgOkAction: title.charAt(0).toUpperCase() + title.slice(1)
                },
                events: {
                    confirmEvent: () => {
                        if (type == 'delete') {
                            this.deletePlanAccount(idPlanAccount)
                        } else if (type == 'edit') {
                            this.editPlanAccount(idPlanAccount)
                        }
                    }
                },
            });
        },
    },
    watch: {
        basicData: {
            handler(data) {
                if (data && data.companyId) {
                    this.basic_data = data;
                    this.loadDefaultPlans();
                    Object.keys(this.basic_data.business_types).map(item => {
                        if (item == 'Servicios') {
                            this.templateName = 'Plan de cuentas - Servicios'
                        } else {
                            this.templateName = 'Plan de cuentas - Productor'
                        }
                    })
                }
            },
            immediate: true,
        },
        indexEditing(newVal) {
            if (!!newVal && newVal >= 0) {
                this.level1Editing = this.account_plans[newVal].level_1;
                this.level3Editing = this.account_plans[newVal].level_3;
                this.orderEditing = this.account_plans[newVal].order;
                this.onLevel1Change(this.level1Editing);
                this.level2Editing = this.level_2_values_depending.find(
                    (item) => item.level_2 == this.account_plans[newVal].level_2,
                ).id;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.download_btn {
    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    max-width: fit-content;

    color: var(--Gray-700, #344054);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
}

.shadow-sm {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
}

/* Colores suaves para diferenciar grupos */
.bg-group-a {
    background-color: #e4ffdf;
}

.bg-group-b {
    background-color: #dbedf6;
    /* Un azul/gris muy tenue */
}

.title_type {
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
    margin-bottom: 2%;
}

.subtitle_type {
    font-weight: bold;
    font-size: 1.15em;
    text-align: center;
    margin-bottom: 2%;
}

.l1 {
    display: block;
    width: 100px;
}

.l2 {
    display: block;
    width: 100px;
}

.new_elem_row {
    margin-left: 10px;
    margin-top: 5px;
}

#level_2_select {
    min-width: 100px;
}

.new_elem_row span select {
    font-weight: bold;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.td_level_2 {
    width: 14em;
}

@mixin theme-button($background-color, $border-color, $color-text) {
    border-radius: 8px;
    background-color: $background-color;
    color: $color-text;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid $border-color;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
}

.theme_btn_dark {
    @include theme-button(#002e33, #002e33, white);
}

.theme_btn_white {
    @include theme-button(white, #ebebeb, black);
}

.theme_btn_red {
    @include theme-button(rgb(193, 61, 21), rgb(193, 61, 21), white);
}

.theme_btn_blue {
    @include theme-button(rgb(94, 119, 244), rgb(94, 119, 244), white);
}
</style>
